"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var BrandContext = /*#__PURE__*/(0, _react.createContext)();
var _default = exports["default"] = BrandContext;